export const currencies = [
  {
    label: 'Kenya Shillings (KES)',
    value: 'KES'
  },
  {
    label: 'Uganda Shillings (UGX)',
    value: 'UGX'
  },
  {
    label: 'Rwandan Franc (RWF)',
    value: 'RWF'
  },
  {
    label: 'US Dollar (USD)',
    value: 'USD'
  }
];
